import './highcharts';
import 'highcharts/es-modules/masters/modules/drilldown.src.js';
import { Chart } from './Chart';
import type { ChartProps } from './Chart';

type BaseChartInstance = Parameters<NonNullable<ChartProps['onReady']>>[0];

export type DrilldownChartInstance = BaseChartInstance & {
  drillUp?: () => void;
  drilldownLevels?: unknown[];
};

type DrilldownChartProps = Omit<ChartProps, 'onReady' | 'options'> & {
  onReady?: (chart: DrilldownChartInstance) => void;
  options?: ChartProps['options'];
};

/**
 * Loads the Highcharts drilldown module before rendering the shared Seeq chart
 * wrapper.
 */
export const DrilldownChart = ({ onReady, options, ...rest }: DrilldownChartProps) => {
  return (
    <Chart {...rest} options={options} onReady={(chart) => onReady?.(chart as unknown as DrilldownChartInstance)} />
  );
};
